import React, { useContext, useMemo } from 'react'
import jwt_decode from 'jwt-decode'
import AuthContext from '../../middlewares/AuthContext'
import AdminDashboard from './dashboards/AdminDashboard'
import CustomerDashboard from './dashboards/CustomerDashboard'
import MarketingDashboard from './dashboards/MarketingDashboard'
import SubpartnerDashboard from './dashboards/SubpartnerDashboard'

interface AuthCtx {
  token: string | null
}

const Dashboard: React.FC = () => {
  const { token }        = useContext(AuthContext) as AuthCtx
  const tokenDecode: any = useMemo(() => (token ? jwt_decode(token) : null), [token])

  const hasRole = (name: string) =>
    tokenDecode?.roles?.some((r: any) => r.name === name)

  return (
    <>
      {(hasRole('admin') || hasRole('partner')) && <AdminDashboard />}
      {hasRole('subpartner')                    && <SubpartnerDashboard />}
      {hasRole('customer')                      && <CustomerDashboard />}
      {hasRole('marketing')                     && <MarketingDashboard />}
    </>
  )
}

export default Dashboard
